import CouchdbClass from 'src/services/CouchdbClass'

let Couchdb

function payloadSettings (Couchdb, payload) {
  if (payload.hasOwnProperty('limit')) {
    Couchdb.limit(payload.limit)
  }
  if (payload.hasOwnProperty('skip')) {
    Couchdb.skip(payload.skip)
  }
  if (payload.hasOwnProperty('sort')) {
    Couchdb.sort(payload.sort)
  }
  if (payload.hasOwnProperty('search')) {
    Couchdb.search(payload.search)
  }
  if (payload.hasOwnProperty('where')) {
    if (payload.where instanceof Array) {
      payload.where.map((item) => {
        for (let key in item) {
          Couchdb.where(key, item[key])
        }
      })
    } else {
      for (let key in payload.where) {
        Couchdb.where(key, payload.where[key])
      }
    }
  }
  if (payload.hasOwnProperty('select')) {
    Couchdb.select(payload.select)
  }
  if (payload.hasOwnProperty('trash')) {
    if (payload.trash) {
      Couchdb.withTrash()
    } else {
      Couchdb.noTrash()
    }
  }
  return Couchdb
}

const mapStates = () => {
  return {
    model: {},
    total: 0,
    dashboardCounter: 0,
    loading: false,
    all: [],
    db: ''
  }
}

const mapGetters = () => {
  return {
    loading: state => state.loading,
    total: state => state.total,
    dashboardCounter: state => state.dashboardCounter,
    modelById: state => state.all.reduce((acc, curr) => {
      acc[curr._id] = curr
      return acc
    }, {}),
    db: state => state.db
  }
}

const mapMutations = () => {
  return {
    UPDATE_DEFAULT_MODEL: (state, payload) => {
      for (let field in payload) {
        if (!state.hasOwnProperty('model')) {
          state.model = {}
        }
        if (state.model.hasOwnProperty(field)) {
          state.model[field] = payload[field]
        }
      }
    },
    setAll: (state, payload) => {
      state.all = payload
    },
    setObjectAll: (state, payload) => {
      state.objAll = payload
    },
    setOne: (state, payload) => {
      state.one = Object.assign({}, state.model, payload)
    },
    changeLoading: (state, payload) => {
      state.loading = payload
    },
    setCount: (state, payload) => {
      state.count = payload
    },
    SET_TOTAL: (state, payload) => {
      state.total = payload
    },
    updateState: (state, payload) => {
      state.one = Object.assign({}, state.one, payload)
    },
    SET_DASHBOARD_COUNTER: (state, payload) => {
      state.dashboardCounter = payload
    },
    SET_DATABASE: (state, db) => {
      state.db = db
    }
  }
}

const mapActions = (collection, model, connection) => {
  // const conn = connection === undefined ? 'default' : connection
  let Couchdb = new CouchdbClass({
    connection: connection || 'default',
    collection: collection || ''
  })

  return {
    getDatabase ({ commit }) {
      console.log(Couchdb.getFullConnection())
      commit('SET_DATABASE', Couchdb.getFullConnection())
      return Couchdb.getFullConnection()
    },
    changeLoading ({ commit }, payload) {
      commit('changeLoading', payload)
    },
    updateDefaultModel ({ commit }, payload) {
      commit('UPDATE_DEFAULT_MODEL', payload)
    },

    insertLogs: (context, logs) => {
      Couchdb.connection('logs').collection('logs')._insertBuckLogs(logs)
    },

    updateMany: (context, payload) => {
      return Couchdb._updateBulkDocs(payload.map(item => {
        item.updatedAt = new Date()
        return item
      }))
    },

    insertMany: (context, payload) => {
      return Couchdb._postBulkDocs(payload.map(item => {
        if (!item.hasOwnProperty('createdAt')) {
          item.createdAt = new Date()
        }
        item.updatedAt = new Date()
        return item
      }))
    },

    setStateAll ({ commit }, payload) {
      commit('setAll', payload)
    },

    setStateOne ({ commit }, payload) {
      commit('setOne', payload)
    },

    setStateObjectAll ({ commit }, payload) {
      commit('setObjectAll', payload)
    },

    /**
     * @param { null | Object } payload Parâmetos de configuração da busca.
     * {
     *   limit: 20,
     *   skip: 0,
     *   sort: {
     *     field: "name",
     *     direction: "ascending"
     *   },
     *   search: {
     *     fields: ["name", "city"]
     *     query: "Stan Lee"
     *   },
     *   where: [
     *     {"userId": "1893e9defc1f8ad145ef34c2520058f3"},
     *     {"active": true}
     *   ],
     *   with: {
     *     customer: {collection: 'customers', localKey: 'customerId',
     *   foreignKey: '_id'}, event: {collection: 'events', localKey: 'eventId',
     *   foreignKey: '_id'}
     *   }
     * }
     * @returns null
     */
    fetchAll: (context, payload) => {
      payload = payload === undefined ? {} : payload
      payload.stateMutations = {
        all: 'setAll'
      }
      return context.dispatch('_all', payload)
    },

    fetchCount: (context, payload) => {
      payload = payload === undefined ? {} : payload
      context.commit('changeLoading', true)
      payload['select'] = ['_id']
      Couchdb = payloadSettings(Couchdb, payload)
      return Couchdb.all()
        .then(result => {
          context.commit('changeLoading', false)
          context.commit('SET_TOTAL', result.length)
          return result.length
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
        })
    },

    /**
     * Get all elements using view and set them into state all
     *
     * @param context
     * @param payload: {
     *      database: database name,
     *      ddoc: design document,
     *      view: view document from design document
     *      key: key used to get the elements
     *      options: extra parameters of request GET on views
     *    }
     */
    fetchViewAll: (context, payload) => {
      context.commit('changeLoading', true)
      payload = payload === undefined ? {} : payload
      return Couchdb.view(payload.ddoc, payload.view, payload.key, payload.options)
        .then(response => {
          if (payload.hasOwnProperty('options') && payload.options.hasOwnProperty('include_docs') && payload.options.include_docs) {
            context.commit('setAll', response.rows.map(item => item.doc))
          } else {
            context.commit('setAll', response.rows.map(item => item.value))
          }
        })
        .catch(err => console.log(err))
        .finally(() => {
          context.commit('changeLoading', false)
        })
    },

    /**
     * Consulta todos os documentos através de uma lista de IDs
     * @param context
     * @param ids
     */
    fetchIds: (context, { connection, ids }) => {
      context.commit('changeLoading', true)
      return Couchdb.connection(connection || 'default')
        ._bulkGet(ids)
        .then(res => {
          context.commit('setAll', res)
          context.commit('changeLoading', false)
          return res
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
          return err
        })
    },

    _all: (context, payload) => {
      payload = payload === undefined ? {} : payload
      context.commit('changeLoading', true)
      Couchdb = payloadSettings(Couchdb, payload)
      return Couchdb.all()
        .then(async result => {
          if (!payload.hasOwnProperty('with')) {
            if (!payload.noCommit) {
              context.commit(payload.stateMutations.all, result)
            }
            context.commit('changeLoading', false)
            return result
          }

          const withPromises = helpers.getWithPromises(result, payload)
          const resultWiths = await Promise.all(withPromises)
          const all = helpers.bindWiths(result, resultWiths, payload)
          if (!payload.noCommit) {
            context.commit(payload.stateMutations.all, all)
          }
          context.commit('changeLoading', false)
          return all
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
        })
    },

    /**
     * @param { null | Object } payload Parâmetos de configuração da busca.
     * {
     *   search: {
     *     fields: ["name", "city"]
     *     query: "Stan Lee"
     *   }
     *   where: [
     *     {"userId": "1893e9defc1f8ad145ef34c2520058f3"},
     *     {"active": true}
     *   ]
     * }
     * @returns null
     */
    count: (context, payload) => {
      context.dispatch('_count', payload)
    },
    _count: (context, payload) => {
      payload = payload === undefined ? {} : payload
      context.commit('changeLoading', true)
      if (payload.hasOwnProperty('where')) {
        payload.where.map((item) => {
          let key = Object.keys(item)
          Couchdb.where(key[0], item[key])
        })
      }
      if (payload.search) {
        Couchdb.search(payload.search)
      }
      Couchdb.collection(collection)
        .count()
        .then(result => {
          context.commit('changeLoading', false)
          context.commit(payload.stateMutations.count, result)
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
        })
    },

    countAllReduce: function (context, payload) {
      const queries = [
        {
          start_key: [collection],
          end_key: [collection, {}],
          reduce: true,
          group_level: 1,
          skip: 0
        }
      ]
      return Couchdb._view({
        ddoc: 'counter-collection-created_at',
        view: 'counter-collection-created_at',
        params: { queries }
      }).then(response => {
        context.commit('setCount', response.rows[0].value)
      })
    },

    /**
     *
     * @param context Variável padrão do vuex
     * @param key     Chave para consulta no banco
     * @param ddoc    DDOC da view
     * @param view    Nome da View
     * @param commmit Nome do commit para atualizar algum estado
     * @returns {Promise<unknown>}
     */
    countByKeyView: function (context, { key, ddoc, view, commit }) {
      const queries = [
        {
          keys: [key],
          reduce: true,
          group: true,
          skip: 0
        }
      ]
      return Couchdb._view({
        ddoc,
        view,
        params: { queries }
      }).then(response => {
        let value = response.hasOwnProperty('rows') && response.rows.length > 0 ? response.rows[0].value : 0
        if (commit) {
          context.commit(commit, value)
        }
        return value
      })
    },

    countByViewBetween: function (context, { start_key, end_key, ddoc, view, commit }) {
      const queries = [
        {
          start_key,
          end_key,
          reduce: true,
          group_level: 1,
          skip: 0
        }
      ]
      return Couchdb._view({
        ddoc,
        view,
        params: { queries }
      }).then(response => {
        if (commit) {
          context.commit(commit, response.rows[0].value)
        }
        return response.rows[0].value
      })
    },

    /**
     * @param { Object | String } payload
     * String: _id do documento a ser buscado.
     * Object:
     * {
     *   docId: "46047262d124574bf12870c38003d066",
     *   with: {
     *     customer: {collection: 'customers', localKey: 'customerId',
     *   foreignKey: '_id'}, event: {collection: 'events', localKey: 'eventId',
     *   foreignKey: '_id'}
     *   }
     * }
     * @returns null
     */
    fetchOne: (context, payload, notCommit) => {
      context.commit('changeLoading', true)
      let docId = payload instanceof Object ? payload.docId : payload
      Couchdb = payloadSettings(Couchdb, payload)
      return Couchdb.collection(collection)
        .find(docId)
        .then(one => {
          if (!one) {
            return false
          }
          if (payload.hasOwnProperty('with')) {
            let result = [one]
            let withPromises = helpers.getWithPromises(result, payload)
            return Promise.all(withPromises)
              .then(resultWiths => {
                helpers.bindWiths(result, resultWiths, payload)
                  .then(all => {
                    if (!notCommit) {
                      context.commit('setOne', all[0])
                    }
                    context.commit('changeLoading', false)
                    return all[0]
                  })
              })
          } else {
            if (!notCommit) {
              context.commit('setOne', one)
            }
            context.commit('changeLoading', false)
            return one
          }
        })
        .catch(err => {
          console.log(err)
          if (!notCommit) {
            context.commit('setOne', {})
          }
          context.commit('changeLoading', false)
          return err
        })
    },

    fetchViewOne: (context, { ddoc, view, key, options, notCommit }) => {
      context.commit('changeLoading', true)
      return Couchdb
        .view(ddoc, view, key, options)
        .then(response => {
          const result = response.rows.map(item => {
            return item.value
          }).reduce((acc, curr) => {
            return curr
          }, {})
          if (!notCommit) {
            context.commit('setOne', result)
          }
          return result
        })
        .catch(err => console.log(err))
        .finally(() => {
          context.commit('changeLoading', false)
        })
    },

    /**
     * @param { String } payload _id do documento a ser buscado.
     * @returns null
     */
    resetOne: (context) => {
      context.commit('setOne', JSON.parse(JSON.stringify(model)))
    },

    /**
     * @param { commit } caller to mutation state
     * @returns null
     */
    resetAll: ({ commit }) => {
      commit('setAll', [])
    },

    /**
     * @param { Object } payload Objeto com os dados que devem ser inseridos no
     *   banco de dados.
     * @returns Promisse
     */
    insert: ({ state, commit, rootState }, payload) => {
      payload.userId = rootState.user._id
      return Couchdb
        .collection(collection)
        .insert(payload)
    },

    insertAttachment: function (context, { docId, doc }) {
      return Couchdb.insertAttachment(docId, doc)
    },

    /**
     * @param { Object } payload Objeto com o _id e os dados que devem ser
     *   atualizado no banco de dados.
     * @returns Promisse
     */
    update: (state, payload) => {
      return Couchdb
        .collection(collection)
        .update(
          payload._id,
          payload
        )
    },

    /**
     * @param { Object } payload Objeto com os dados que devem ser inseridos ou
     *   atualizados no banco de dados. Caso o _id seja passado no objeto a
     *   operação realizada será de atualização.
     * @returns Promisse
     */
    upset: (state, payload) => {
      return Couchdb
        .collection(collection)
        .upset(
          payload._id,
          payload
        )
    },

    upsert: async (state, payload, database) => {
      return Couchdb.upsert(payload._id, payload, database)
    },

    /**
     * @param { String } docId _id do objeto que será deletado.
     * @returns Promisse
     */
    delete: (context, docId) => {
      return Couchdb
        .collection(collection)
        .delete(docId)
    },

    updateState: ({ commit }, payload) => {
      if (typeof payload === 'object') {
        commit('updateState', payload)
      }
    },

    updateWithView: function (context, payload) {
      return Couchdb.updateWithView(payload)
    },

    insertAll: (context, docs) => {
      return Couchdb.collection(collection)._insertBulk(docs)
    },

    updateAll: (context, docs) => {
      return Couchdb
        .collection(collection)
        ._updateBulkDocs(docs)
    },
    findMany: (context, { keys, commit }) => {
      return Couchdb.findMany(keys)
        .then(result => {
          if (commit === false) {
            return result
          }
          context.commit('setAll', result)
          return result
        })
    },

    /*
     * Parameters:
     *   find: {database, ddoc, view}
     *   payload: {data to be upserted}
     */
    upsertWithView (context, { find, payload }) {
      return Couchdb.upsertWithView(Object.assign({}, find, { payload }))
    }
  }
}

const helpers = {
  getWithPromises: (result, payload, conn = 'default') => {
    let withPromises = []
    for (const key in payload.with) {
      if (payload.with.hasOwnProperty(key)) {
        const item = payload.with[key]
        let keys = result
          .map((row) => {
            return row[item.localKey]
          })
          .filter((key) => {
            return key !== null && key !== undefined
          })
        withPromises.push(Couchdb
          .collection(item.collection)
          .whereIn(item.foreignKey, keys)
          .all())
      }
    }
    return withPromises
  },
  bindWiths: (result, resultWiths, payload) => {
    return new Promise((resolve, reject) => {
      let i = 0
      for (const key in payload.with) {
        const item = payload.with[key]
        result.map((row) => {
          row[key] = resultWiths[i].find((obj) => {
            return obj[item.foreignKey] === row[item.localKey]
          })
        })
        i++
      }
      resolve(result)
    })
  }
}

export { mapActions, mapMutations, mapStates, mapGetters }




// WEBPACK FOOTER //
// ./src/vuex/baseModule.js